module.exports = __webpack_public_path__ + "static/img/vhs.1aacb56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vhs.png
// module id = 8Auz
// module chunks = 1